import React from 'react'
import error from '../../assets/error404.avif';
export default function Notfound() {
  return <div className='text-center pt-5'> 

<h2 className=''> This Page Not Found </h2>
  
  
  <img src={error} alt=""  />
  
  </div>
}
